/** Normalización de texto para búsquedas tokenizadas en SQLite (productos). */

import { buildAccentInsensitiveSqlExpression, normalizeSearchText } from '../../shared/format/searchText';

export const normalizeSearchInput = (value: string) => normalizeSearchText(value);

export const tokenizeSearchInput = (value: string) =>
  normalizeSearchInput(value).split(/\s+/).filter(Boolean);

export const buildNormalizedSqlExpression = (column: string) =>
  buildAccentInsensitiveSqlExpression(column);

export function appendSearchTokenClauses(
  clauses: string[],
  params: Array<string | number>,
  tokens: string[],
  fields: string[]
): void {
  for (const token of tokens) {
    clauses.push(`(${fields.map((field) => `${buildNormalizedSqlExpression(field)} LIKE ?`).join(' OR ')})`);
    params.push(...fields.map(() => `%${token}%`));
  }
}
